import React, { Component } from 'react'
// connect方法的作用：将额外的props传递给组件，并返回新的组件，组件在该过程中不会受到影响
import { connect } from 'react-redux'

import './Articlelist.css'
import { NetGet } from '../../axios'
import { toast } from 'react-toastify'
import ReactPaginate from 'react-paginate';
import { Link } from "react-router-dom";
import Code from '../../page/writeart/code-block'
import {getQueryVariable} from '../../tool/tools'

import LazyImg from '../lazyimg'

const ReactMarkdown = require('react-markdown')


class Artivlelist extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data: -1,
            total: 0
        }
        this.focus = false
        this.page = 1
    }

    componentDidMount() {
        this.handlePageClick(this.page)
    }

    handlePageClick = (data) => {
        var { clientHeight } = document.documentElement
        this.focus && (document.documentElement.scrollTop = clientHeight - (clientHeight * 3 / 100))

        this.focus = true
        let page = data.selected >= 0 ? data.selected + 1 : 1;
        this.page = page
        let param = { page: page, limit: 10 }
        var search = getQueryVariable("search")
        if(search){
            param.search = search
        }
        NetGet("artlist", param)
            .then((e) => {

                if (e.code == 0) {



                    this.setState({
                        data: e.data,
                        total: e.total
                    })
                } else {
                    toast.error("文章获取失败 !");
                    this.setState({
                        total: "文章获取失败"
                    })
                }
            })
            .catch(() => {
                toast.error("文章获取失败 !");
                this.setState({
                    total: "文章获取失败"
                })
            })
    }
    goArticle = (id) => {
        console.log(this.props.history)
        window.location.href = `#/Article?id=${id}`
        // this.props.history.push('/Article')
    }


    codesub = (data) => {
        //.replace(/\(.*?\)/g,'').replace(/\<.*?\>/g,'').replace(/\```.*?\```/g,'').replace(/\r\n/g,"").replace(/```/g,"").replace(/#/g,"").replace(/\*/g,"").replace(/`/g,"")
        return data.replace(/\[.*?\]|\(.*?\)|\<.*?\>|\```.*?\```|\r\n|```|#|\*|`|-|/g, '')//去掉mark符号

    }







    render() {
        const input = 'javascript //Ocean 是基于 Hexo 默认主题 landscape 的功能，设计的一款支持移动设备的主题，并且集成了 Gitalk 与 Valine 评论功能。 由于我是一枚 Designer 而不是 Coder，所以 欢迎指正！'
        const { data } = this.state
        const { url } = window.myurl
        //"https://2heng.xin/wp-content/uploads//2018/06/child-1024x576.jpg"
        return (
            <>
                {/* <h1 class="main-title" style={{ fontFamily: "'Ubuntu', sans-serif" }}><i class="fa fa-envira" aria-hidden="true"></i> Discovery</h1> */}
                {
                    data != -1 && data.map((item, index) => {
                        return <div className={`article-inner post-list-show ${index % 2 != 0 ? '' : 'flex-row-reverse '}`} key={`artlist${index}`}>
                            <div class="blur-img">
                                <LazyImg
                                    errimg={"https://cdn.jsdelivr.net/gh/A-ANing/manifest_s@master/myblog/images/onerr/98fca04416944b282a558b98b2131879.png"}
                                    src={item.posvimg}
                                />
                            </div>
                            <div className="article-img" style={{ float: index % 2 != 0 ? "right" : "left" }}>
                                <a className="article-title" href={`${url}/article/${item.id}`} target="view_window">
                                    <LazyImg
                                        errimg={"https://cdn.jsdelivr.net/gh/A-ANing/manifest_s@master/myblog/images/onerr/98fca04416944b282a558b98b2131879.png"}
                                        loadimg={"https://cdn.jsdelivr.net/gh/A-ANing/manifest_s@master/myblog/images/onloading/orange.progress-bar-stripe-loader.svg"}
                                        src={item.posvimg}

                                    />

                                </a>
                            </div>
                            <div className="article-code" >
                                <header>
                                    <div className="post-date"> <i className="iconfont icon-time"></i><label class="push-time-text">发布于</label> {item.time}</div>

                                    <div className="post-meta">
                                        <span><i className="iconfont icon-attention"></i>{item.readnum} <label class="arlt-read-text">阅读</label></span>
                                        <span className="comments-number">
                                            <i className="iconfont icon-mark"></i>
                                            <a href={`${url}/article/${item.id}#comment`} target="view_window">{item.count}评论</a>
                                        </span>
                                        <span>
                                            <i className="iconfont icon-file"></i><a href="/tags/type/">{item.sort_name}</a>
                                        </span>
                                    </div>

                                </header>


                                <div>
                                    <h3 itemProp="name">
                                        <a className="article-title" href={`${url}/article/${item.id}`} target="view_window">{item.title}</a>
                                    </h3>
                                </div>






                                <div className="article-entry  mark-down" itemProp="articleBody">
                                    <a href={`${url}/article/${item.id}`} target="view_window">{this.codesub(item.body)}</a>
                                    {/* <ReactMarkdown
                                        source={item.body}
                                        escapeHtml={false}
                                        skipHtml={false}
                                        renderers={{ code: Code }}
                                    /> */}
                                    {/* <div className="post-bottom" style={{textAlign:index%2!=0?'left':'right'}}>
                                        <a href={`${url}/article/${item.id}`} className="button-normal" target="view_window">
                                            <i className="iconfont icon-caidan"></i>
                                        </a>
                                    </div> */}
                                    {/* <Link className="article-more-link" to={`/Article?id=${item.id}`}>阅读全文...</Link> */}


                                </div>
                            </div>



                            {/* <footer className="article-footer">
                                <a data-url="https://zhwangart.github.io/2018/11/30/Ocean/" data-id="ckazhfh5a001kq746a9svx432" className="article-share-link">分享</a>

                                <ul className="article-tag-list">
                                    <li className="article-tag-list-item">
                                        <a className="article-tag-list-link" href="/tags/Hexo/">
                                            {item.sort_name}
                                        </a>
                                    </li>
                                    <li className="article-tag-list-item">
                                        <a className="article-tag-list-link" href="/tags/Ocean/">
                                            {item.sort_name}
                                        </a>
                                    </li>
                                </ul>

                            </footer> */}

                        </div>
                    })
                }
                {
                    Math.ceil(this.state.total / 10) > 0 &&
                    <ReactPaginate
                        previousLabel={'上一页'}
                        nextLabel={'下一页'}
                        breakLabel={'...'}
                        breakClassName={'break-me'}
                        pageCount={Math.ceil(this.state.total / 10)}//总页数
                        marginPagesDisplayed={1}
                        pageRangeDisplayed={1}
                        onPageChange={this.handlePageClick}
                        containerClassName={'pagination'}
                        subContainerClassName={'pages pagination'}
                        activeClassName={'active'}
                    />
                }

            </>




        )
    }
}


export default connect()(Artivlelist)